import { useState } from 'react';

export default function useEventTracking({learnerId, credentialAwardId,
    institutionId, institutionName}) {
    const [shared, setShared] = useState(null);

    const eventTrackingForm = new URLSearchParams();
    eventTrackingForm.append('eventName', 'Award.Share.Indiana.Wallet');
    eventTrackingForm.append('shareChannel', 'INDIANA_ACHIEVEMENT_WALLET');
    eventTrackingForm.append('learnerId', learnerId);
    eventTrackingForm.append('credentialAwardId', credentialAwardId);
    eventTrackingForm.append('institutionId', institutionId);
    eventTrackingForm.append('institutionName', institutionName);
    eventTrackingForm.append('pageSource', 'Credential Award Page');

    const handleEventTracking = async () => {
        const trackEvent = await fetch( '/u/track', {
            method: 'POST',
            body: eventTrackingForm
        });
        const response = await trackEvent.json();
        setShared(response.success);
    };

    const resetSharedState = () => {
        setShared(null);
    };

    return { shared, handleEventTracking, resetSharedState };
}
